import classNames from 'classnames';
import type { FC, HTMLAttributes } from 'react';
import styles from './Divider.module.css';

export const Divider: FC<HTMLAttributes<HTMLHRElement>> = ({
  children,
  className,
  ...rest
}) => {
  return <hr className={classNames(styles.divider, className)} {...rest} />;
};
